import FragmentPage from '../core/FragmentPage';

export default class VideosPage extends FragmentPage {
  constructor(meta) {
    super('videos', meta);
  }
}
